export const QCM_TYPES = [
  { value: 'exercice', label: 'Exercice', color: 'bg-slate-100 text-slate-700' },
  { value: 'positionnement', label: 'Positionnement', color: 'bg-sky-100 text-sky-700' },
  { value: 'initial', label: 'Initial', color: 'bg-amber-100 text-amber-800' },
  { value: 'final', label: 'Final', color: 'bg-emerald-100 text-emerald-700' },
];

export const qcmTypeLabel = (v) => QCM_TYPES.find(t => t.value === v)?.label || (v ? v.charAt(0).toUpperCase() + v.slice(1) : '');
export const qcmTypeColor = (v) => QCM_TYPES.find(t => t.value === v)?.color || 'bg-slate-100 text-slate-600';
